import React from 'react';

const pageHeader = (props) => (
  <div className="contact-header">
    <div className="container">
      <div className="row">
        <div className="col-md-4 offset-md-4">
          <h3 className="contact-header__subtitle">Budimo u kontaktu</h3>
        </div>
      </div>
    </div>
  </div>
);

export default pageHeader;